import Messenger from "./_gears/Messenger";
import { DOMAIN, QA_DOMAIN } from "config/config";
import SettingPanel from "./_gears/SlideMenu/setting-panel";
import { backendConnector, DATA_LINK } from "connectors";
import { Talk2GPTDetails } from "Components/Talk2GPTDetails/Talk2GPTDetails";
const tabs = [
  // {
  //   label: "HR Document QA",
  //   icon: "",
  //   reqAuth: "None",
  //   iconPos: "left",
  //   noTransform: true,
  //   render: <Messenger name={"HR Document QA"} LiveChatEnabled={true} viaBackend={false} url={process.env.NODE_ENV === "development" ? `${QA_DOMAIN}/Talk2VA` : `${QA_DOMAIN}/swireqa/Talk2VA`} />,
  // },
  // {
  //   label: "SYVA Small Talk",
  //   icon: "",
  //   reqAuth: "None",
  //   iconPos: "left",
  //   noTransform: true,
  //   render: <Messenger name={"SYVA Small Talk"} LiveChatEnabled={true} viaBackend={false} url={process.env.NODE_ENV === "development" ? `${QA_DOMAIN}/Talk2VA` : `${QA_DOMAIN}/smalltalk/Talk2VA`} />,
  // },
  {
    label: "SYVA GPT-QA Hybrid",
    icon: "",
    reqAuth: "GPTQA.TestChat.Hybrid",
    iconPos: "left",
    noTransform: true,
    render: (addOns, setAddOns) => (
      <Messenger
        name={"SYVA GPT-QA"}
        project={addOns?.project}
        historyUrl={`${DOMAIN}${DATA_LINK.DMRemove_History}`}
        LiveChatEnabled={false}
        viaBackend={true}
        url={`${DOMAIN}${DATA_LINK.DMTalk2VA_HYBRID}`}
        feedbackUrl={`${DOMAIN}${DATA_LINK.UserFeedback}`}
      />
    ),
    settingComponent: (addOns, setAddOns) => <SettingPanel addOns={addOns} setAddOns={setAddOns} />,
    showSetting: true,
  },
  {
    label: "SYVA GPT-QA",
    icon: "",
    reqAuth: "GPTQA.TestChat.GPTQA",
    iconPos: "left",
    noTransform: true,
    render: (addOns, setAddOns) => (
      <Messenger
        name={"SYVA GPT-QA"}
        project={addOns?.project}
        LiveChatEnabled={false}
        viaBackend={true}
        historyUrl={`${DOMAIN}${DATA_LINK.DMRemove_History}`}
        feedbackUrl={`${DOMAIN}${DATA_LINK.UserFeedback}`}
        url={`${DOMAIN}${DATA_LINK.DMTalk2GPTAsync}`}
        streamUrl={`${DOMAIN}${DATA_LINK.DMTalk2GPT_STREAM}`}
        referenceUrl={`${DOMAIN}${DATA_LINK.DMReference}`}
        followupQuestionUrl={`${DOMAIN}${DATA_LINK.DMFollowupQuestion}`}
        streamOutput={true}
        onMounted={(callbalcks) => {
          setAddOns({ ...addOns, messengerCallbacks: callbalcks });
        }}
        onMsgSent={(msg, id) => {
          setAddOns({ ...addOns, payload: msg });
        }}
        onMsgSelected={(msgId, msg, record) => {
          setAddOns({ ...addOns, payload: record });
        }}
      />
    ),
    settingComponent: (addOns, setAddOns) => <SettingPanel addOns={addOns} setAddOns={setAddOns} />,
    showSetting: true,
    detailsComponent: (addOns, setAddOns) => <Talk2GPTDetails addOns={addOns} />,
    showDetails: true,
  },
  {
    label: "SYVA GPT-QA (Advanced Reasoning)",
    icon: "",
    reqAuth: "GPTQA.TestChat.AdvancedReasoning",
    iconPos: "left",
    noTransform: true,
    render: (addOns, setAddOns) => (
      <Messenger
        name={"SYVA GPT-QA"}
        project={addOns?.project}
        LiveChatEnabled={false}
        viaBackend={true}
        url={`${DOMAIN}${DATA_LINK.DMTalk2GPT}`}
        historyUrl={`${DOMAIN}${DATA_LINK.DMRemove_History}`}
        feedbackUrl={`${DOMAIN}${DATA_LINK.UserFeedback}`}
        onMounted={(callbalcks) => {
          setAddOns({ ...addOns, messengerCallbacks: callbalcks });
        }}
        onMsgSent={(msg, id) => {
          setAddOns({ ...addOns, payload: msg });
        }}
        onMsgSelected={(msgId, msg, record) => {
          setAddOns({ ...addOns, payload: record });
        }}
      />
    ),
    settingComponent: (addOns, setAddOns) => <SettingPanel addOns={addOns} setAddOns={setAddOns} />,
    showSetting: true,
    detailsComponent: (addOns, setAddOns) => <Talk2GPTDetails addOns={addOns} />,
    showDetails: true,
  },
];

export default tabs;
